<template>
	<div>
		<el-row :gutter="24" style="min-width:500px">
			<h3 style="padding-left: 10px;">现金红包列表</h3>
			<div style="padding-left: 10px; float: right;">
				<el-button type="primary" style="margin:10px" @click="add()">添加现金红包</el-button>
			</div>
			<el-table :data="tableData" :header-cell-style="{ background: '#F2F2F4', 'text-align': 'center' }"
				:cell-style="{'text-align': 'center'}">
				<el-table-column prop="actName" label="活动名" align="center"></el-table-column>
				<el-table-column prop="totalAmount" label="金额" align="center">
					<template slot-scope="scope">
						￥{{scope.row.totalAmount/100}}
					</template>
				</el-table-column>
				<el-table-column prop="sceneId" label="场景" align="center">
					<template slot-scope="scope">
						{{scope.row.sceneId}}
					</template>
				</el-table-column>
				<el-table-column prop="wishing" label="祝福语" align="center"></el-table-column>
				<el-table-column prop="remark" label="备注"></el-table-column>
				<el-table-column prop="isClose" label="状态">
					<template slot-scope="scope">
						{{isClose?'上架':'下架'}}
					</template>
				</el-table-column>
				<el-table-column width="180" label="操作">
					<template slot-scope="scope">
						<el-button type="text" @click="deit(scope.row.id)" style="margin-right: 30px;">编辑</el-button>
						<el-button type="text" @click="hiddenordel(scope.row.id)" style="color: red;">
							删除
						</el-button>
					</template>
				</el-table-column>
			</el-table>
		</el-row>
		<div style="text-align: center;">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page="query.page" :page-sizes="[10, 20, 30, 50]" :page-size="10"
				layout="total,sizes, prev, pager, next, jumper" :total="query.total">
			</el-pagination>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				tableData: [],
				sceneList: [{
					key: 'PRODUCT_1',
					value: '商品促销',
				}, {
					key: 'PRODUCT_2',
					value: '抽奖',
				}, {
					key: 'PRODUCT_3',
					value: '虚拟物品兑奖',
				}, {
					key: 'PRODUCT_4',
					value: '企业内部福利',
				}, {
					key: 'PRODUCT_5',
					value: '渠道分润',
				}, {
					key: 'PRODUCT_6',
					value: '保险回馈',
				}, {
					key: 'PRODUCT_7',
					value: '彩票派奖',
				}, {
					key: 'PRODUCT_8',
					value: '税务刮奖',
				}, ],
				query: {
					page: 0,
					size: 10,
				},
				total: '',
			}
		},
		mounted() {
			this.getList()
		},
		methods: {
			getList() {
				this.$http.get("dRedpackSetting/list" + "?pageNum=" + this.query.page + "&pageSize=" + this.query.size)
					.then(res => {
						this.tableData = res.body.data
						this.total = res.body.total
						this.tableData.forEach(t => {
							this.sceneList.forEach(s => {
								if (t.sceneId == s.key) {
									t.sceneId = s.value
								}
							})
						})
					})
			},
			add() {
				this.$router.push("/redPackDetail")
			},
			deit(id) {
				this.$router.push({
					path: '/redPackDetail',
					query: {
						id: id
					}
				})
			},
			hiddenordel(id) {
				this.$confirm('此操作将永久删除该活动, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.get("dRedpackSetting/delete" + "?id=" + id).then(res => {
						if (res.body.code == 200) {
							this.$message.success("删除成功")
							this.getList()
						}
					});
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			handleSizeChange(val) {
				this.query.size = val;
				this.getList();
			},
			handleCurrentChange(val) {
				this.query.page = val
				this.getList();
			},
		}
	}
</script>

<style>
</style>